import sc from '@/api/score-component'
import mainProgram from '@/api/main-program'
import grade from '@/api/grade'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return sc.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return sc.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await sc.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update(context, { id, data }) {
    return sc.update(id, data)
  },
  getMainProgram(context) {
    return mainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGrade(context, acp_id) {
    return grade.get({
      params: {
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        filter: {
          by_main_program: acp_id,
          score_type: 2, // grading,
          score_item_base: 1 // item base
        },
        page: -1
      }
    })
  }
}
